import React from 'react';
import './main.less';

const isEverad = process.env.CPA_ENV === 'everad';

function Logo() {
	return isEverad ? (
		<a className="main-menu__logo-wrapper">
			<span className="main-menu__logo-icon-everad" />
			<span className="main-menu__logo-everad font-proxima-nova-semibold">
				Everad
			</span>
		</a>
	) : (
		<a className="main-menu__logo-wrapper">
			<span className="main-menu__logo-icon-rocket" />
			<span className="main-menu__logo-rocket font-proxima-nova-bold">
				Rocket<span>Profit</span>
			</span>
		</a>
	);
}

export default Logo;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/sidebar/components/logo/main.js